import { merge } from '../helper';

// ----------------------------------------------------------------------------

export type TypeNumberToTimeConfig = {
    format?: 'HH:MM:SS' | 'MM:SS' | 'SS';
};

// ----------------------------------------------------------------------------

function numberToTime(value: string | number, config: TypeNumberToTimeConfig = {}): string {
    // Default Config
    const defConfig = {
        format: 'HH:MM:SS',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // If config is string
    if (typeof config === 'string') {
        defConfig.format = config;
    }

    const num = parseInt(String(value), 10);

    const hours = Math.floor(num / 3600);
    const minutes = Math.floor((num % 3600) / 60);
    const seconds = num % 60;

    const HH = String(hours).padStart(2, '0');
    const MM = String(minutes).padStart(2, '0');
    const SS = String(seconds).padStart(2, '0');

    if (defConfig.format === 'MM:SS') {
        return `${MM}:${SS}`;
    }

    if (defConfig.format === 'SS') {
        return SS;
    }

    return `${HH}:${MM}:${SS}`;
}

// ----------------------------------------------------------------------------

export { numberToTime };
